import React from "react";
import "./Schedule.scss";

const LOCATIONS = [
  { key: "plavnieki", name: "Pļavnieki" },
  { key: "karlaUlmana", name: "Kārļa Ulmaņa gatve 150" },
  { key: "kurzemes", name: "Kurzemes prospekts 3G" },
];

const WEEK = [
  { key: "mon", name: "Pirmdiena" },
  { key: "tue", name: "Otrdiena" },
  { key: "wed", name: "Trešdiena" },
  { key: "thu", name: "Ceturtdiena" },
  { key: "fri", name: "Piektdiena" },
  { key: "sat", name: "Sestdiena" },
  { key: "sun", name: "Svētdiena" },
];

const morningTraining = {
  time: "≈ 07:00–09:00",
  group: "Visiem",
  activity: "Cīņas sports + VFS",
};

const kurzemesTraining = {
  time: "17:30–19:00",
  group: "Visiem",
  activity: "Kikbokss, MMA",
};

const SCHEDULE = {
  mon: {
    plavnieki: [
      morningTraining,
      {
        time: "16:30–18:00",
        group: "Bērni 7–13 gadi",
        activity: "Kikbokss, Muay Thai",
      },
      {
        time: "17:00–18:00",
        group: "Bērni 4–6 gadi",
        activity: "VFS",
      },
      {
        time: "18:00–20:00",
        group: "Jaunieši 13+ un pieaugušie",
        activity: "Kikbokss, Muay Thai",
      },
    ],
    karlaUlmana: [],
    kurzemes: [kurzemesTraining],
  },

  tue: {
    plavnieki: [
      morningTraining,
      {
        time: "16:30–18:00",
        group: "Visiem",
        activity: "Bokss",
      },
      {
        time: "19:00–21:00",
        group: "Visiem",
        activity: "MMA",
      },
    ],
    karlaUlmana: [
      {
        time: "17:00–18:00",
        group: "11+",
        activity: "Treniņš",
      },
      {
        time: "18:00–19:00",
        group: "Bērni 4–10 gadi",
        activity: "Treniņš",
      },
    ],
    kurzemes: [kurzemesTraining],
  },

  wed: {
    plavnieki: [
      morningTraining,
      {
        time: "16:30–18:00",
        group: "Bērni 7–13 gadi",
        activity: "Kikbokss, Muay Thai",
      },
      {
        time: "17:00–18:00",
        group: "Bērni 4–6 gadi",
        activity: "VFS",
      },
      {
        time: "18:00–20:00",
        group: "Jaunieši 13+ un pieaugušie",
        activity: "Kikbokss, Muay Thai",
      },
    ],
    karlaUlmana: [],
    kurzemes: [kurzemesTraining],
  },

  thu: {
    plavnieki: [
      morningTraining,
      {
        time: "16:30–18:00",
        group: "Visiem",
        activity: "Bokss",
      },
      {
        time: "19:00–21:00",
        group: "Visiem",
        activity: "MMA",
      },
    ],
    karlaUlmana: [
      {
        time: "17:00–18:00",
        group: "11+",
        activity: "Treniņš",
      },
      {
        time: "18:00–19:00",
        group: "Bērni 4–10 gadi",
        activity: "Treniņš",
      },
    ],
    kurzemes: [kurzemesTraining],
  },

  fri: {
    plavnieki: [
      morningTraining,
      {
        time: "16:30–18:00",
        group: "Bērni 7–13 gadi",
        activity: "Kikbokss, Muay Thai",
      },
      {
        time: "17:00–18:00",
        group: "Bērni 4–6 gadi",
        activity: "VFS",
      },
      {
        time: "18:00–20:00",
        group: "Jaunieši 13+ un pieaugušie",
        activity: "Kikbokss, Muay Thai",
      },
    ],
    karlaUlmana: [],
    kurzemes: [kurzemesTraining],
  },

  sat: {
    plavnieki: [
      morningTraining,
      {
        time: "11:00–13:00",
        group: "Visiem",
        activity: "MMA",
      },
    ],
    karlaUlmana: [],
    kurzemes: [kurzemesTraining],
  },

  sun: {
    plavnieki: [],
    karlaUlmana: [],
    kurzemes: [],
  },
};

function ScheduleSlot({ sessions }) {
  if (!sessions?.length) {
    return <div className="slot slot--empty">—</div>;
  }

  return (
    <div className="slot">
      {sessions.map((session, index) => (
        <div
          className="slot__item"
          key={`${session.time}-${session.group}-${index}`}
        >
          <div className="slot__line">
            <span className="slot__label">{session.group}</span>
            <span className="slot__time">{session.time}</span>
          </div>

          <div className="slot__activity">{session.activity}</div>
        </div>
      ))}
    </div>
  );
}

export default function Schedule() {
  return (
    <section id="schedule" className="section schedule-section">
      <div className="container">
        <header className="section__head">
          <h2>Treniņu grafiks</h2>
          <p className="muted">
            Izvēlies sev ērtāko lokāciju, dienu un treniņu grupu.
          </p>
        </header>

        <div className="schedule">
          <div className="schedule__head">
            <div className="schedule__cell schedule__cell--head">Diena</div>

            {LOCATIONS.map((location) => (
              <div
                key={location.key}
                className="schedule__cell schedule__cell--head"
              >
                {location.name}
              </div>
            ))}
          </div>

          {WEEK.map((day) => (
            <div key={day.key} className="schedule__row">
              <div className="schedule__cell schedule__day">
                <div className="schedule__dayname">{day.name}</div>
              </div>

              {LOCATIONS.map((location) => (
                <div
                  key={location.key}
                  className="schedule__cell schedule__slot"
                  data-loc={location.name}
                  aria-label={`${day.name} — ${location.name}`}
                >
                  <ScheduleSlot
                    sessions={SCHEDULE[day.key]?.[location.key] || []}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}